import { render, staticRenderFns } from "./creatCdkey.vue?vue&type=template&id=50395d9a&scoped=true"
import script from "./creatCdkey.vue?vue&type=script&setup=true&lang=js"
export * from "./creatCdkey.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creatCdkey.vue?vue&type=style&index=0&id=50395d9a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50395d9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50395d9a')) {
      api.createRecord('50395d9a', component.options)
    } else {
      api.reload('50395d9a', component.options)
    }
    module.hot.accept("./creatCdkey.vue?vue&type=template&id=50395d9a&scoped=true", function () {
      api.rerender('50395d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/cdkey/creatCdkey.vue"
export default component.exports